import { Button, Input, List, message, Modal } from "antd";
import React, { ReactNode, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { connect } from "dvajs";
import { useTranslation } from "react-i18next";
import { EbookState } from "@/models/ebook";
import "./index.less";
import externalContactsSuccess from "@/assets/img/externalContacts/success.png";
import externalContactsFail from "@/assets/img/externalContacts/fail.png";
import { TeamApplyStatus } from "@/types/chat/enum";
import * as util from "@/components/Joyspace/util";
import { changeEgovUrl } from "@/utils/tools";
import { contactsListInfo } from ".";

function ExternalItem({
  data: item,
  handleClouseRefuse,
  handleAdd,
  titleNode
}: {
  data: contactsListInfo;
  handleClouseRefuse: Function;
  handleAdd: Function;
  titleNode: any;
}) {
  const [t] = useTranslation("chat");
  const [refusalCause, setRefusalCause] = useState("");
  const contentNode = useMemo(() => {
    return (
      <div className={`teams-applies-content `}>
        <div className="content-title">{titleNode}</div>
        {item.adminName && (
          <div>
            <span className="label">审批人：</span>
            <span className="container">{item.adminName}</span>
          </div>
        )}
        {item.userName && (
          <div>
            <span className="label">申请人：</span>
            <span className="container">{item.userName}</span>
          </div>
        )}
        {/* {item.applyReason && (
          <div>
            <span className="label">申请原因：</span>
            <span
              className="container"
              dangerouslySetInnerHTML={{
                __html: item.applyReason?.replace(/\n/g, "<br/>")
              }}
            />
          </div>
        )} */}

        {item.rejectReason && (
          <div>
            <span className="label">驳回原因：</span>
            <span
              className="container"
              dangerouslySetInnerHTML={{
                __html: item.rejectReason?.replace(/\n/g, "<br/>")
              }}
            />
          </div>
        )}
        {item.gmtCreate && (
          <div>
            <span className="label">申请时间：</span>
            <span className="container">{util.chineseTime.format(item.gmtCreate)}</span>
          </div>
        )}
        {item.approveTime && (
          <div>
            <span className="label">审核时间:</span>
            <span className="container">{util.chineseTime.format(item.approveTime)}</span>
          </div>
        )}
      </div>
    );
  }, [item, t, titleNode]);

  const textareaNode = useMemo(() => {
    return (
      <div className="refusal-cause">
        <Input.TextArea
          placeholder="请输入驳回原因"
          rows={4}
          defaultValue={refusalCause}
          onChange={(e) => {
            setRefusalCause(e.target.value.trim());
          }}
          maxLength={100}
        />
        <p className="refusal-cause-length">
          <span>{refusalCause.length || 0}</span>
          /100
        </p>
        <p className="refusal-cause-btns">
          <Button
            className="refusal-cause-btns-cancel"
            onClick={() => {
              setRefusalCause("");
              handleClouseRefuse(item, false);
            }}
          >
            {t("cancelText")}
          </Button>
          <Button
            disabled={!refusalCause}
            className="refusal-cause-btns-ok"
            type="primary"
            loading={item.loading}
            onClick={() => {
              handleAdd(item, 3, refusalCause);
            }}
          >
            {t("confirm")}
          </Button>
        </p>
      </div>
    );
  }, [handleAdd, handleClouseRefuse, item, refusalCause, t]);

  return (
    <div className="teams-applies-list-item ">
      {/* 蒙层 */}
      {/* {(item.approveStatus === TeamApplyStatus.INVALID ||
        item.approveStatus === TeamApplyStatus.ALREADY_APPR ||
        item.approveStatus === TeamApplyStatus.ALREADY_EXSIT) && (
        <div className="teams-applies-list-item-Mantle"> </div>
      )} */}
      <div className="teams-applies-item-detail">
        {contentNode}
        <div className="teams-applies-status">
          {item.approveStatus === TeamApplyStatus.SUCCESS && (
            <img src={changeEgovUrl(externalContactsSuccess)} alt="" />
          )}
          {item.approveStatus === TeamApplyStatus.FAIL && (
            <img src={changeEgovUrl(externalContactsFail)} alt="" />
          )}
        </div>
      </div>
      {item.refuse && textareaNode}
      <div className="teams-applies-item-fun">
        {item.approveStatus === TeamApplyStatus.WAIT && !item.refuse && (
          <>
            <Button
              className="refuse"
              onClick={() => {
                handleClouseRefuse(item, true);
              }}
            >
              {t("not approved")}
            </Button>
            <Button
              className="agreed"
              type="primary"
              loading={item.loading}
              onClick={() => {
                handleAdd(item, 2);
              }}
            >
              {t("approved")}
            </Button>
          </>
        )}
      </div>
    </div>
  );
}

function mapStateToProps({ ebook }: { ebook: EbookState }) {
  return {};
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(ExternalItem);
